import { toast } from '@mobiscroll/react-latest'

interface IToastProps {
  duration?: number
  color: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info'
  message: string
  onClose?: () => void
}

export const notification = ({ duration = 5000, color, message, onClose }: IToastProps): void => {
  toast({
    color,
    display: 'top',
    duration,
    message
  })
}



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Notification.tsx